module.exports = __webpack_public_path__ + "static/img/icon_online-message.19bea86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_online-message.png
// module id = R61e
// module chunks = 1